import { getKeys } from './getKeys'

export const noticeboardTranslations = {
  TITLE: 'Noticeboard',
  FORM_TITLE: 'Title',
  CREATE: 'Create Notice',
  POST: 'Post',
  BACK: 'Back',
  UNREAD: 'Unread',
  READ_MORE: 'Read more',
  EDIT: 'Edit Notice',
  TEAM_MEMBERS: 'TEAM MEMBERS',
  LAST_UPDATED_BY: 'Last updated by',
  LAST_UPDATED_AT: 'Last updated at',
  LAST_UPDATED_ON: 'Last updated on',
  TABLE_TITLE: 'Title',
  READ_BY: 'Read by',
  NOT_READ_BY: 'Not read by',
  MESSAGE: 'Message',
  VIEW: 'View',
  NO_NOTICES_YET: 'Ready, set, go! The journey starts here',
  NO_NOTICES_YET_DESCRIPTION:
    'Press that blue button at the top right of the page to create your first notice.',
  TOAST_DELETE: 'Notice deleted successfully',
  TOAST_CREATE: 'New notice created',
  TOAST_UPDATE: 'Notice updated successfully',
  NO_HTML: 'This field must be populated',
  DELETE_CONFIRMATION_TEXT: 'This will remove the notice permanently.',
  DELETE_CONFIRMATION_TITLE: 'Are you sure you want to delete?',
  TITLE_TOO_LONG: 'Title cannot exceed 100 characters.',
  NOT_ALLOWED_TITLE: 'Pssst... This page is undercover',
  NOT_ALLOWED_DESCRIPTION:
    'You do not have permission view this page, speak to your manager if you think this is a mistake.',
}

export const noticeboardConstants = getKeys(noticeboardTranslations)
